<template>
  <div>
    <nav>
      <v-app-bar app tile flat class="pa-0 gradient-bg" dark>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-spacer />
        <v-toolbar-title class="text-uppercase">{{
          isOrganizer ? user.name : poll.title
        }}</v-toolbar-title>
        <v-spacer />

        <UserMenu @logout="$emit('showLogoutDialog')" />

        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            centered
            active-class="font-weight-bold"
            show-arrows
          >
            <v-tab v-for="(tab, i) in tabList" :key="i">
              <v-icon left small>
                {{ tab.icon }}
              </v-icon>
              {{ tab.title }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" app v-if="$route.name !== 'Vote'">
        <template v-slot:prepend>
          <div
            class="d-flex justify-center align-center text-center px-3"
            style="padding-top: 33.2px; padding-bottom: 33.2px"
          >
            <Logo :filename="`logo-color.svg`" :isDisabled="true" />
          </div>

          <v-divider></v-divider>

          <template v-if="isOrganizer">
            <div class="pa-3">
              <v-btn block depressed class="secondary" @click="createNewPoll">
                <v-icon left small>mdi-plus</v-icon> create poll
              </v-btn>
            </div>
            <v-divider></v-divider>
          </template>
        </template>

        <v-list nav class="pa-3">
          <v-list-item
            v-for="(poll, i) in polls"
            :key="i"
            link
            :to="{ name: 'Manage', params: { id: poll.id } }"
            active-class="font-weight-bold primary white--text"
          >
            <v-list-item-content>
              <v-list-item-title>{{ poll.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </nav>

    <v-overlay :value="overlay" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(tab, i) in tabList" :key="i">
        <v-row>
          <v-col class="mx-auto pa-8 my-3" cols="12" sm="10" md="8">
            <component v-bind="tab.props" :is="tab.component"></component>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {
  Analytics,
  CreatePoll,
  Sections,
  Voters,
  Agents,
  UserMenu,
} from "@/components/organizer";
import Logo from "@/components/Logo.vue";
import { mapActions } from "vuex";

export default {
  components: {
    CreatePoll,
    Sections,
    Voters,
    Analytics,
    Agents,
    UserMenu,
    Logo,
  },

  data: () => ({
    overlay: false,
    drawer: true,

    tab: null,
    tabList: null,
  }),

  methods: {
    ...mapActions(["makeFetch", "updateCollection"]),

    createNewPoll() {
      this.$router.push({ name: "Create" });
    },

    async loadData() {
      this.overlay = true;

      // get poll info
      await this.makeFetch({
        method: "get",
        goTo: `/polls/${this.$route.params.id}`,
        stateVar: "poll",
      }).catch(console.error);

      // get sections
      await this.makeFetch({
        method: "get",
        goTo: `/polls/${this.$route.params.id}`,
        way: "/sections",
        stateVar: "sections",
      }).catch(console.error);

      // get voters
      await this.makeFetch({
        method: "get",
        goTo: `/polls/${this.$route.params.id}`,
        way: "/voters",
        stateVar: "voters",
      }).catch(console.error);

      // get analytics
      await this.makeFetch({
        method: "get",
        goTo: `/polls/${this.$route.params.id}`,
        way: "/analytics",
        stateVar: "analytics",
      }).catch(console.error);

      this.overlay = false;

      // get agents
      await this.makeFetch({
        method: "get",
        goTo: `/polls/${this.$route.params.id}`,
        way: "/agents",
        stateVar: "agents",
      }).catch(console.error);
    },

    makeTabList() {
      const tabs = [
        {
          icon: "mdi-chart-histogram",
          title: "Poll",
          component: "CreatePoll",
          props: {
            largeBtn: false,
          },
        },
        {
          icon: "mdi-order-bool-descending-variant",
          title: "Sections",
          component: "Sections",
        },
        {
          icon: "mdi-thumbs-up-down",
          title: "Voters",
          component: "Voters",
        },
        {
          icon: "mdi-chart-arc",
          title: "Analytics",
          component: "Analytics",
        },
        {
          icon: "mdi-account-group",
          title: "Agents",
          component: "Agents",
        },
      ];

      const userType = localStorage.getItem("typ")[0];
      if (userType === "o") this.tabList = [...tabs];
      else
        this.tabList = tabs.filter((item) =>
          ["voters", "analytics"].includes(item.title.toLowerCase())
        );
    },
  },

  computed: {
    polls() {
      return this.$store.getters.getCollection("polls");
    },

    user() {
      const usr = localStorage.getItem("usr");
      return JSON.parse(usr);
    },

    isOrganizer() {
      return localStorage.getItem("typ")[0] === "o";
    },

    poll() {
      return (
        this.polls.filter((item) => item.id == this.$route.params.id)[0] || {
          title: "",
        }
      );
    },
  },

  async beforeRouteUpdate(to, from, next) {
    next();
    await this.loadData();
  },

  mounted() {
    this.makeTabList();
  },
};
</script>

<style scoped>
.gradient-bg {
  background-image: linear-gradient(to left, #005cff, #2d9bfc, #3de0ff);
  background-size: cover;
}
</style>
